import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"
import Image from "next/image"

export default function NameAndAvatarBadge(props: {
  imgSrc?: string
  name: string
  className?: string
  imgClassName?: string
}) {
  return (
    <Badge
      variant="muted"
      className={cn(
        "h-6 text-sm flex items-center px-2 space-x-2 ",
        props.className
      )}
    >
      {props.imgSrc && (
        <Image
          src={props.imgSrc}
          alt="Blog icon"
          width={16}
          height={16}
          className={cn("rounded-full", props.imgClassName)}
        />
      )}
      <span className="truncate max-w-[180px] font-normal text-muted-foreground font-sans">
        {props.name}
      </span>
    </Badge>
  )
}
